import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import { setHistoryRoute } from "../actions";

const mapStateToProps = ( state ) =>
{
	return {
		user: state.user
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		setHistoryRoute: ( a_route ) =>
		{
			dispatch( setHistoryRoute( a_route ) );
		}
	};
};

class Access extends React.Component
{
	static isPermitted( user, permissions = [], exactly = false )
	{
		let result = false;
		
		// Inaktive Nutzer oder Nutzer ohne Berechtigungen abweisen
		if ( !user || !user.isActive || user.permissions.length === 0 )
		{
			return false;
		}
		
		// LLS-Benutzer dürfen alles, Prüfung auf Gastrechte ausschließen
		if ( user.permissions.indexOf( "super_user_permissions" ) !== -1 && !exactly && Object.keys( permissions ).filter( a_key => permissions[ a_key ] === "guest_user_permissions" ).length === 0 )
		{
			return true;
		}
		
		// Prüfe auf Berechtigungen
		Object.keys( permissions ).forEach(
			( a_key ) =>
			{
				const permission = permissions[ a_key ];
				
				if ( user.permissions.indexOf( permission ) !== -1 )
				{
					return result = true;
				}
			}
		);
		
		return result;
	}
	
	render()
	{
		const { user, permissions = [], errorContent = null, exactly = false } = this.props;
		
		// Prüfung ob die gesuchte Rolle oder Berechtigung enthalten ist.
		// Optional: Prüfe explizit auf Berechtigung wenn 'exactly' aktiviert wurde.
		if ( Access.isPermitted( user, permissions, exactly ) )
		{
			// Inline Elemente ausgeben
			return this.props.children;
		}
		else if ( this.props.redirectTo )
		{
			// Redirect erst wenn der Benutzer festgestellt wurde
			if ( this.props.user !== null )
			{
				// vorherige Route merken
				this.props.setHistoryRoute( this.props.location.pathname );
				
				// Auf Fehlerseite Umleiten
				return <Redirect to={this.props.redirectTo}/>;
			}
		}
		
		return errorContent;
		
	} // function render()
}

Access.propTypes = {
	permissions: PropTypes.array,
	errorContent: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ),
	exactly: PropTypes.bool
};

Access = connect(
	mapStateToProps,
	mapDispatchToProps
)( Access );

export default withRouter( Access );